import {
  Spinner,
  __experimentalItemGroup as ItemGroup,
  __experimentalItem as Item,
} from "@wordpress/components";
import { styled } from "goober";

export const InputWrapper = styled("div")`
  select.components-select-control__input {
    padding-right: 10px !important;
    color: var(--wp-admin-theme-color, #0073aa) !important;
    font-size: 12px !important;

    &:focus {
      outline: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  }

  .components-input-control-suffix-wrapper {
    display: none;
    color: var(--wp-admin-theme-color, #0073aa) !important;
  }

  .components-select-control .components-input-control__backdrop {
    display: none !important;
  }

  components-input-control-suffix-wrapper .components-input-control__backdrop {
    display: none !important;
  }
`;

export const Container = styled("div")`
  max-height: 300px;
  max-width: 100%;
  overflow-y: auto;
  position: relative;

  .components-input-control__backdrop {
    display: none !important;
  }
`;

export const SuggestionList = styled(ItemGroup)`
  padding: 0;
`;

export const SuggestionItem = styled(Item)<{ highlighted?: boolean }>`
  background: ${({ highlighted }) => (highlighted ? "#f0f0f0" : "transparent")};
  cursor: pointer;
  hyphens: auto;

  &:hover {
    background: #f0f0f0;
  }

  &:active {
    background: #e0e0e0;
  }
`;

export const Footer = styled("div")`
  padding: 10px;
  font-size: 14px;
  color: #666;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9f9f9;
  border-top: 1px solid #e0e0e0;
  position: sticky;
  bottom: 0;
  gap: 8px;
`;

export const StyledSpinner = styled(Spinner)`
  width: 12px;
  margin-right: 2px;
`;

export const SuffixWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;

  * {
    margin: 0 !important;
    box-shadow: none !important;
  }

  .components-input-control__backdrop {
    display: none !important;
  }
`;

export const Help = styled("div")`
  margin-top: 4px !important;
  font-size: 12px !important;
  color: #666;
`;
